import meActionCreator from '../../actioncreators/me';
import messagesActionCreator from '../../actioncreators/messages';
import applicationActionCreator from '../../actioncreators/application';
import UtilityHelper from '../../utils/helpers';
import { staticConstants } from '../../utils/constants';
import { ErrorCodes, AddEmailAtLoginObligationFlow } from '@idm/authentication-flows';
import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const { toastMessage, errorCodes, errorNotificationEvents } = staticConstants;
const authFlowsErrorCodes = ErrorCodes;

class AddEmailAtLoginPageContainer extends React.Component {
  static propTypes = {
    authenticationMethods: PropTypes.arrayOf(PropTypes.shape),
    dispatchInitialize: PropTypes.func.isRequired,
    dispatchCodeSentToastMessage: PropTypes.func.isRequired,
    dispatchErrorToastMessage: PropTypes.func.isRequired,
    dispatchAddEmailComplete: PropTypes.func.isRequired,
    dispatchCancel: PropTypes.func.isRequired,
    language: PropTypes.string,
    location: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    isRequireAdpEmailFlagEnabled: PropTypes.bool,
  };

  static defaultProps = {
    authenticationMethods: null,
    language: null,
    isRequireAdpEmailFlagEnabled: false,
  };

  componentDidMount() {
    const { dispatchInitialize, location } = this.props;
    const redirectUrl = encodeURIComponent(`${location.pathname}${location.search}`);
    const redirectLocation = {
      pathname: '/auth/login',
      search: `?redirectUrl=${redirectUrl}`,
    };

    dispatchInitialize(redirectLocation);
  }

  render() {
    const {
      dispatchErrorToastMessage,
      dispatchCodeSentToastMessage,
      dispatchCancel,
      dispatchAddEmailComplete,
      language,
      isRequireAdpEmailFlagEnabled,
      authenticationMethods,
    } = this.props;

    return (
      <div className="add-email">
        <AddEmailAtLoginObligationFlow
          onError={dispatchErrorToastMessage}
          isRequireAdpEmailFlagEnabled={isRequireAdpEmailFlagEnabled}
          onCodeSent={dispatchCodeSentToastMessage}
          onCancel={dispatchCancel}
          onSuccess={dispatchAddEmailComplete}
          language={language}
          userInfo={authenticationMethods}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { accountSettingsLocalization } = state;

  return {
    language: accountSettingsLocalization.main.language,
  };
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatchInitialize(redirectLocation) {
    dispatch(meActionCreator.checkAuthentication(redirectLocation));
  },

  dispatchCodeSentToastMessage() {
    const toastMessageAction = messagesActionCreator.addToastMessage({
      message: 'CODE_SENT',
      type: toastMessage.SUCCESS_TOAST_TYPE,
      id: UtilityHelper.generateUniqueId(),
      translationNamespace: toastMessage.TOAST_I18N_NAMESPACE,
    });

    dispatch(toastMessageAction);
  },

  dispatchErrorToastMessage(code, error) {
    let errorMessage = errorNotificationEvents.ADD_EMAIL_ERROR;

    if (error.code === errorCodes.EMAIL_ALREADY_EXISTS) {
      errorMessage = errorNotificationEvents.DUPE_EMAIL_ERROR;
    } else if (code === authFlowsErrorCodes.INVALID_EMAIL) {
      errorMessage = errorNotificationEvents.INVALID_EMAIL;
    }

    const toastMessageAction = messagesActionCreator.addToastMessage({
      message: errorMessage,
      type: toastMessage.FAILURE_TOAST_TYPE,
      id: UtilityHelper.generateUniqueId(),
      translationNamespace: toastMessage.TOAST_I18N_NAMESPACE,
    });

    dispatch(toastMessageAction);
  },

  async dispatchAddEmailComplete() {
    const queryString = ownProps.location.search;
    const { redirectUrl } = UtilityHelper.parseQueryString(queryString);
    const defaultSuccessUrl = '/';
    const successLocation = redirectUrl || defaultSuccessUrl;

    await applicationActionCreator.clearObligations();
    applicationActionCreator.changeUrl(successLocation);
  },

  dispatchCancel() {
    const queryString = ownProps.location.search;
    const { cancelUrl } = UtilityHelper.parseQueryString(queryString);
    const defaultCancelUrl = '/auth/logout';
    const cancelLocation = cancelUrl || defaultCancelUrl;

    applicationActionCreator.changeUrl(cancelLocation);
  },
});

const AddEmailAtLoginPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(AddEmailAtLoginPageContainer);

export default AddEmailAtLoginPage;
